module.exports = __webpack_public_path__ + "static/dummy_cut-f1129ee54148f027ac724cb10fe2faaf.png";